import React from 'react'
import { isMobile } from 'react-device-detect'
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelIcon,
} from 'pixel-base'
import styled from 'styled-components'

import { addInvoiceShippingLine, addShippingLine } from 'utils/api-routes.util'
import {
  IPixelFactory,
  OrderDetail,
  OrderShipping,
} from '../../../../../../decl.d'
interface IProps {
  shippingMethod: OrderShipping[]
  handleClose: () => void
  detailID: number
  shippingDetails: OrderShipping[]
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
}
const AddEditShippingLine = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const {
    shippingMethod,
    handleClose,
    detailID,
    shippingDetails,
    newOrder,
    newOrderData,
    setNewOrderData,
    isItInvoice,
  } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    amount: null,
    method_id: null,
  })
  const [newOrderShipping, setNewOrderShipping] = React.useState({
    item_id: null,
    method_id: null,
    method_title: null,
    total: null,
  })
  const handleSubmit = () => {
    if (newOrder === true) {
      setNewOrderData({
        ...newOrderData,
        shipping_lines: [
          ...(newOrderData?.shipping_lines || {}),
          newOrderShipping,
        ],
      })
      handleClose()
    } else {
      handleAddShppingLine()
    }
  }
  const handleResponse = (res: any) => {
    hidePageLoader()
    if (res.response.data) {
      showSuccess('Successfully Added')
      handleClose(res.response.data)
    } else {
      if (res.response.error && res.response.field) {
        setError({
          error: res.response.error,
          field: res.response.field,
        })
      } else {
        showFailure(res.response.error)
      }
    }
  }
  const handleAddShppingLine = () => {
    showPageLoader()
    if (isItInvoice) {
      addInvoiceShippingLine(detailID, data).subscribe(handleResponse)
    } else {
      addShippingLine(detailID, data).subscribe(handleResponse)
    }
  }
  React.useEffect(() => {
    if (newOrder === true) {
      if (shippingDetails?.length > 0) {
        setNewOrderShipping({
          ...newOrderShipping,
          item_id: newOrderData?.shipping_lines?.[0]?.item_id,
          method_id: newOrderData?.shipping_lines?.[0]?.method_id,
          method_title: newOrderData?.shipping_lines?.[0]?.method_title,
          total: newOrderData?.shipping_lines?.[0]?.total,
        })
      }
    }
  }, [])
  React.useEffect(() => {
    if (shippingDetails?.length > 0) {
      setData({
        amount: shippingDetails?.map((item) => {
          return item.total
        }),

        method_id: shippingDetails?.map((item) => {
          return item.method_title
        }),
      })
    }
  }, [shippingDetails])
  const handleNegativePrice = (e) => {
    if (e.key === '-') {
      e.preventDefault()
      showFailure('Shipping can not be Negative')
    }
  }
  return (
    <>
      <FormContainer>
        <FormGroup>
          <DcDropDown
            dropdownSize={isMobile ? 'sm' : 'md'}
            error={
              error.field === 'method_id' && error.error !== ''
                ? error.error
                : null
            }
            options={[...shippingMethod].map((data) => {
              return {
                label: `${data?.title?.slice(0, 30)}${
                  data?.title?.length > 30 ? '...' : ''
                }`,
                value: data.id,
              }
            })}
            placeholder={'Shipping Method'}
            name={'Shipping Method'}
            value={newOrder ? newOrderShipping.method_id : data?.method_id}
            onChange={(e) => {
              if (newOrder) {
                setNewOrderShipping({
                  ...newOrderShipping,

                  method_id: e.target.value,
                  method_title: e.target.options[e.target.selectedIndex].text,
                })
              } else {
                setData({ ...data, method_id: e.target.value })
              }
            }}
          />
          <DcInput
            inputSize={isMobile ? 'small' : 'medium'}
            error={
              error.field === 'amount' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'number'}
            min={'0'}
            name={'amount'}
            placeholder={'Amount'}
            value={newOrder === true ? newOrderShipping.total : data.amount}
            onKeyDown={handleNegativePrice}
            onChange={(e) => {
              if (newOrder === true) {
                setNewOrderShipping({
                  ...newOrderShipping,
                  total: e.target.value,
                })
              } else {
                setData({ ...data, amount: e.target.value })
              }
            }}
          />
        </FormGroup>
        <Actions>
          <DcButton
            size={'sm'}
            onClick={() => {
              handleClose()
            }}
            variant="link"
          >
            <PixelIcon
              icon={faXmark}
              color={$DCprimaryColor}
              showTooltip
              tooltip="Cancel"
            />
          </DcButton>
          <DcButton
            disabled={
              !newOrder
                ? !data.amount || !data.method_id
                : !newOrderShipping.total || !newOrderShipping.method_id
            }
            size="sm"
            onClick={handleSubmit}
            variant="link"
          >
            <PixelIcon
              icon={faCheck}
              color={$DCprimaryColor}
              showTooltip
              tooltip="Update"
            />
          </DcButton>
        </Actions>
      </FormContainer>
    </>
  )
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: ${isMobile ? '0px' : '10px'};
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 75%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 10px;
  width: 25%;
`
export default AddEditShippingLine
